"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrderRate = getOrderRate;
exports.getOrderRateYoy = getOrderRateYoy;

var _request = _interopRequireDefault(require("@/utils/request"));

function getOrderRate(data) {
  return (0, _request.default)({
    url: '/api/data/order-rate',
    method: 'get',
    params: data
  });
}

function getOrderRateYoy(data) {
  return (0, _request.default)({
    url: '/api/data/order-rate-yoy',
    method: 'get',
    params: data
  });
}